import axios from '../../config/axios';


  const apiGetStoreList = async (lat, lng, page, limit) => {

    try {
      const result = await axios.get(`/merchant/new/list?loc_lat=${lat}&loc_lng=${lng}&cur_page=${page}&per_page=${limit}`
      )
      return result
    } catch (error) {
      return error && error.response && error.response.data
    }
  }

  const apiGetProduct = async (id) => {

    try {
      const result = await axios.get(`/product/list?merchant_id=${id}`
      )
      return result
    } catch (error) {
      return error && error.response && error.response.data
    }
  }

  const apiCreateBasket = async (data) => {
  

    try {
      const result = await axios.post(`/order`, data
      )
      return result
    } catch (error) {
      return error && error.response && error.response.data
    }
  }

  const apiFirstBasket = async (data) => {

    try {
      const result = await axios.post(`/order/product`, data
      )
      return result
    } catch (error) {
      return error && error.response && error.response.data
    }
  }

  const apiUpdateBasket = async (data) => {
    // console.log(data)

    try {
      const result = await axios.put(`/order`, data
      )
      return result
    } catch (error) {
      return error && error.response && error.response.data
    }
  }


  const apiGetProductBasket = async (id, lat, lng) => {

    try {
      const result = await axios.get(`/order?order_id=${id}&lat=${lat}&lng=${lng}`
      )
      return result
    } catch (error) {
      return error && error.response && error.response.data
    }
  }

  const apiComfirm = async (id, lat, lng) => {

    try {
      const result = await axios.get(`/order/checkout?order_id=${id}&lat=${lat}&lng=${lng}`
      )
      return result
    } catch (error) {
      return error && error.response && error.response.data
    }
  }

  const apiPaid = async (data) => {

    try {
      const result = await axios.post(`/order/paid`, data
      )
      return result
    } catch (error) {
      return error && error.response && error.response.data
    }
  }

  export {
    apiGetStoreList,
    apiGetProduct,
    apiCreateBasket,
    apiGetProductBasket,
    apiFirstBasket,
    apiUpdateBasket,
    apiComfirm,
    apiPaid
}